import React from 'react';
import clsx from 'clsx';
import { CardContent, Theme, Typography } from '@mui/material';
import { Styles } from '@mui/styles/withStyles/withStyles';
import { makeStyles, withStyles } from '@mui/styles';

const styles: Styles<Theme, any> = ({ spacing, transitions }: Theme) => {
  const transition = transitions.create('opacity', {
    duration: transitions.duration.shorter,
  });

  return {
    root: {
      display: 'flex',
      padding: spacing(0.5, 1),
      '&:last-child': {
        paddingBottom: `${spacing(0.5)} !important`,
      },
    },
    title: {
      fontSize: 16,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
    },
    editButton: {
      fontSize: 12,
      marginLeft: spacing(0.5),
      transition,
    },
  };
};

const useStyles = makeStyles(styles);

interface Props {
  className?: {
    root?: string;
    title?: string;
  };
  title: string;
}

function LoyaltyItemTitleComponent({ className = {}, title }: Props): React.ReactElement {
  const classes = useStyles({});

  return (
    <CardContent className={clsx(classes.root, className.root)}>
      <Typography variant="h3" className={clsx(classes.title, className.title)}>
        {title}
      </Typography>
    </CardContent>
  );
}

export const LoyaltyItemTitle = withStyles(styles)(LoyaltyItemTitleComponent);
